import { ChangeEvent, FormEvent, useState } from "react";
import {
  VuiFlexContainer,
  VuiFlexItem,
  VuiSearchInput,
  VuiLink,
  VuiSpacer,
  VuiTitle,
  VuiTextColor,
} from "../ui";

type Props = {
  searchValue?: string;
  setSearchValue: (searchValue: string | undefined) => void;
  onSearch: (searchValue?: string) => void;
};

export const Header = ({ searchValue, setSearchValue, onSearch }: Props) => {
  const onSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  const onSearchSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch(searchValue);
  };

  return (
    <div className="header">
      <VuiFlexContainer alignItems="center" justifyContent="spaceBetween">
        <VuiFlexItem grow={0}>
          <a
            href="https://www.vectara.com"
            target="_blank"
            rel="noreferrer noopener"
          >
            <img src="img/logo.png" alt="Vectara logo" height="20" />
          </a>
        </VuiFlexItem>

        <VuiFlexItem grow={1}>
          <VuiTitle size="xs" align="right">
            <VuiTextColor color="subdued">
              <h1>
                Conversational search demo across{" "}
                <VuiLink target="_blank" href="https://www.quantamagazine.org/">
                  Quanta Magazine
                </VuiLink>{" "}
                articles
              </h1>
            </VuiTextColor>
          </VuiTitle>
        </VuiFlexItem>
      </VuiFlexContainer>

      <VuiSpacer size="m" />

      <VuiSearchInput
        value={searchValue}
        onChange={onSearchChange}
        onSubmit={onSearchSubmit}
        placeholder="Ask me anything..."
        autoFocus
      />
    </div>
  );
};
